import { gql } from '@apollo/client';

import { TGood } from 'types';

export interface IGoodsResponse {
  goods: Array<Pick<TGood, 'eans' | 'id' | 'title'>>;
}
export const GOODS = gql`
  query goods {
    goods {
      id
      title
      eans
      vat
    }
  }
`;
